module.exports = __webpack_public_path__ + "static/predictivepoem 24-01-2706679b197720fc441ab6d9a07fc4a6.jpg";